module.exports = __webpack_public_path__ + "static/media/golfer-4-b.0404ff45.png";